import BaseView from "./_BaseView";
import Table from "../components/Table";
import Confirm from "../components/Confirm";
import Api from "../Api";

export default class IgnoreRuleView extends BaseView {
    constructor() {
        super();
        this.formSelector = '#ignoreRuleForm';
        this.formUrl = '/api/ignorerules';
        this.formTpl = 'ignore-rule-form';
        this.formTitle = Lang.ignorerules;
        this.defaultObject = {
            description: '',
            rule: '',
            notes: ''
        };
        this.formCallback = function () {
            this.table.reload();
        };
    }

    init() {
        super.init();

        const container = $('#ignore-rules');
        if (container.length > 0) {
            const url = container.data('id') !== undefined ? '/api/ignorerules/table?app_type_id=' + container.data('id') : '/api/ignorerules/table';
            this.table = new Table('ignore-rules', url, [
                {data: 'description', orderable: true},
                {data: 'type'},
                {data: 'rule'},
                {data: 'notes'},
                {data: 'tools', orderable: false},
            ]);
        }
    }


    getFormData() {
        const data = super.getFormData();
        data.app_type_id = $('#ignore-rules').data('id') !== undefined ? $('#ignore-rules').data('id') : null;
        return data;
    }

    setEvents() {
        super.setEvents();
        const self = this;
        const section = $('#ignore-rules');

        //Add
        section.parents('main').find('.add-ignore-rule').on("click", function () {
            self.renderForm();
            return false;
        });

        //Delete
        section.on("click", ".delete", function () {
            const id = $(this).parents('div:eq(0)').data('id');
            const name = $(this).parents('tr').find('td:eq(0)').text();

            Confirm({
                ok: Lang.delete,
                title: name,
                msg: `${Lang.delsure}<br><br><strong class="msg-box danger">${Lang.delundone}</strong>`,
                onConfirm: function () {
                    Api.send(`/api/ignorerules/${id}`, {}, 'delete').done(function () {
                        self.table.reload();
                    });
                }
            });

            return false;
        });

        //Edit
        section.on("click", ".edit", function () {
            const id = $(this).parents('div:eq(0)').data('id');

            Api.send(`/api/ignorerules/${id}`).done(function (r) {
                self.renderForm(r);
            });
            return false;
        });
    }
}
